const container = "shrink-0 py-2 md:py-4";

const controlsInner = "flex flex-col items-center gap-3";

const scrapeBtn = "w-full md:w-72 text-base";

const icon = "mr-2 h-5 w-5";

export { container, controlsInner, scrapeBtn, icon };
